import React from "react";
import NavBarContainer from "../../containers/NavBar/NavBarContainer";
import PrestamosParametrizadosManager from "./PrestamosParametrizadosManager";

export default function PrestamosParametrizadosPage() {
  return (
    <div className="flex flex-col h-screen bg-slate-100 overflow-hidden">
      <nav className="fixed top-0 left-0 right-0 z-50 h-14 bg-gradient-to-r from-custom-green-ccard-2 to-custom-green-ccard-1">
        <NavBarContainer />
      </nav>
      <div className="flex-1 pt-14 overflow-y-auto [scrollbar-gutter:stable]">
        <div className="p-8">
          <PrestamosParametrizadosManager />
        </div>
      </div>
    </div>
  );
}
